import type { CreateStaffingBesetzung } from '@projektverwaltung/shared';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../../../lib/api.js';
import { UserPicker } from '../../user-picker.js';
import { EINGABE_RAHMEN } from '../inline-feld.js';
import { useMaske, useMaskeKnopf } from './maske-kontext.js';

const KNOPF = 'text-xs hover:underline';

/** Lokale Zeile „+ Person besetzen": legt die Besetzung an, sobald eine Person feststeht. */
export function NeueBesetzung({
  positionId,
  onFertig,
}: {
  positionId: string;
  onFertig: () => void;
}) {
  const { t } = useTranslation();
  const { projectId } = useMaske();
  const knopf = useMaskeKnopf();
  const [extern, setExtern] = useState(false);
  const [externName, setExternName] = useState('');

  const anlegen = (person: { user_id: string } | { extern_name: string }) => {
    const input: CreateStaffingBesetzung = { ...person, beauftragte_position_id: positionId };
    knopf(async () => {
      await api.createStaffingBesetzung(projectId, input);
      onFertig();
    });
  };

  return (
    <div className="flex flex-wrap items-center gap-2 py-1 text-sm">
      <label className="flex items-center gap-1 text-xs" style={{ color: 'var(--ink-2)' }}>
        <input type="checkbox" checked={extern} onChange={(e) => setExtern(e.target.checked)} />
        {t('v2.staffing_maske.extern', 'extern')}
      </label>
      {extern ? (
        <>
          <input
            type="text"
            aria-label={t('v2.staffing_maske.extern_name', 'Name (extern)')}
            placeholder={t('v2.staffing_maske.extern_name', 'Name (extern)')}
            className={`rounded px-2 py-1 text-sm ${EINGABE_RAHMEN}`}
            value={externName}
            onChange={(e) => setExternName(e.target.value)}
          />
          <button
            type="button"
            className={KNOPF}
            style={{ color: 'var(--primary)' }}
            disabled={externName.trim() === ''}
            onClick={() => anlegen({ extern_name: externName.trim() })}
          >
            {t('v2.staffing_maske.extern_uebernehmen', 'Übernehmen')}
          </button>
        </>
      ) : (
        <UserPicker
          value={null}
          allowClear={false}
          placeholder={t('v2.staffing_maske.person_waehlen', 'Person wählen')}
          onChange={(u) => {
            if (u) anlegen({ user_id: u.user_id });
          }}
        />
      )}
      <button
        type="button"
        className={KNOPF}
        style={{ color: 'var(--ink-3)' }}
        aria-label={t('v2.staffing_maske.besetzen_verwerfen', 'Neue Besetzung verwerfen')}
        onClick={onFertig}
      >
        ✕
      </button>
    </div>
  );
}
